<template>
    <div class="firstpage" @click="close()">
      <Header v-if="!minip2"></Header>
      <!-- <img :src="bgkv" alt="" srcset="">
      <img :src="bg1" alt="" srcset="">
      <img :src="bg2" alt="" srcset=""> -->
      <!-- <img :src="bg3" alt="" srcset=""> -->
      <!-- <img :src="bg4" alt="" srcset=""> -->
      <img :src="bgSpring" alt="" srcset="">
      <Footer v-if="!minip2" />
      <ShareBar v-if="!minip2"></ShareBar>
    </div>
  </template>

  <script>
  import { isPortraitFun, getUrlKey, isAndroid } from "@/utils/utils.js";
  import Header from "@/components/Header";
  import Footer from "@/components/Footer";
  import ShareBar from "@/components/ShareBar.vue"
  import $ from 'jquery'
  import QRCode from 'qrcodejs2'
  import mShare from "@/utils/mShare"
  // import myBMap from "@/utils/myBMap";
  export default {
    components: {
        Header,
        Footer,
        ShareBar
    },
    data() {
      return {
        isPortrait: isPortraitFun(),
        minip: false,
        minip2:false,
        /**
        bgkv: "/assets/~/media/images/activity/salespolicy/1.png",
        bg1: "/assets/~/media/images/activity/salespolicy/2.png",
        bg2: "/assets/~/media/images/activity/salespolicy/3.png",
        bg3: "/assets/~/media/images/activity/salespolicy/4.png",
        bg4: "/assets/~/media/images/activity/salespolicy/5.png",
         **/
        bgSpring: "/assets/~/media/images/activity/2026/salespolicy/mob.png",
      };
    },
    computed: {
    },
    mounted: function () {
      //mob生成二维码
      // document.getElementById('qrcodeCanvas').src = `https://kiacarservice-uat.kia.cn/kia-carservice-api/QRCode/getQRcode?url=${window.location.href}`
      if (window.location.href.includes("https://uat.kia.cn")) {
          //生成二维码

          document.getElementById('qrcodeCanvas').src = `https://kiacarservice-uat.kia.cn/kia-carservice-api/QRCode/getQRcode?url=${window.location.href}`
      } else {

          document.getElementById('qrcodeCanvas').src = `https://kiacarservice.kia.cn/kia-carservice-api/QRCode/getQRcode?url=${window.location.href}`
      }
      if (getUrlKey("minip") && getUrlKey("minip") == 2) {
        this.minip2 = true;
      }
    },
    unmounted() {
    },
    methods: {
      //新增分享方法 start
      shareToWeibo(){//分享微博
        this.closePopup()
        //url不能带#
        const weiboShareUrl = `http://service.weibo.com/share/share.php?title=${document.title}&pic=https://www.kia.cn/assets/~/media/images/dyk/index/footer/weibo-share-link.jpg&url=${window.location.href}`;
        window.open(weiboShareUrl);
      },
      shareCopy(){//复制
        if(document.execCommand("Copy")){
          try {
            var txtEl = document.createElement('textarea');
            txtEl.value = window.location.href;
            document.body.appendChild(txtEl);
            txtEl.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            txtEl.remove();

            this.closePopup()
            const popup = document.getElementById('popup');
            setTimeout(function() {
                popup.style.display = 'flex';
                setTimeout(function() {
                    popup.style.display = 'none';
                }, 1000);
            }, 0);
          } catch(err) {
            // 复制失败
            console.log(err);
          }
        }else{
          navigator.clipboard.writeText(window.location.href).then(() => {
            this.closePopup()
            const popup = document.getElementById('popup');
            setTimeout(function() {
                popup.style.display = 'flex';
                setTimeout(function() {
                    popup.style.display = 'none';
                }, 1000);
            }, 0);
          }).catch((err) => {
              console.log(err);
          });
        }
      },
      //关闭弹窗
      closePopup(){
        var isShow = document.getElementById("popup-mob-share");
        isShow.style.display = "none";
        var isShow1 = document.getElementById("qr-popup-mob-share");//关闭二维码
        isShow1.style.display = "none";
      },
      sharePopup(){//弹出分享弹窗
        var isShow = document.getElementById("popup-mob-share");
        if(isShow.style.display !== "flex"){
          isShow.style.display = "flex";
        }else{
          isShow.style.display = "none";
          var isShow1 = document.getElementById("qr-popup-mob-share");//关闭二维码
          isShow1.style.display = "none";
        }
      },
      //微信分享
      shareWechat(){
        var UA = navigator.appVersion;
        var uc = UA.split('UCBrowser/').length > 1 ? 1 : 0;
        var qq = UA.split('MQQBrowser/').length > 1 ? 2 : 0;
        var wx = /micromessenger/i.test(UA);
        if(uc || (qq && !wx)){
          this.closePopup()
          var mshare = new mShare({
            title: document.title,
            url: window.location.href,
            desc: '',
            img: 'https://www.kia.cn/assets/~/media/images/dyk/index/footer/weibo-share-link.jpg'
          });
          setTimeout(function(){
            mshare.init(2);
          },800)
        }else{
          var isShow = document.getElementById("qr-popup-mob-share");
          if(isShow.style.display !== "flex"){
            isShow.style.display = "flex";
          }else{
            isShow.style.display = "none";
          }
        }
      }
      //end
      },
    };
  </script>

  <style lang="scss" scoped>
  .firstpage {
    position: relative;
    // height: 100%;
    // padding-bottom: 230px;
    width: 100%;
    overflow-y: auto;
    user-select: none;
    background-color: #000000;

    @media(max-width: 768px) {
      img {
        margin-top: -1px;
      }
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    object {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .swiper-box {
      width: 100%;
      overflow: hidden;
    }

    .my-form-box {
      width: 100%;
      //
      display: flex;
      align-items: flex-end;
      position: fixed;
      bottom: 0;
      border-radius: 10px 10px 0px 0px;
      z-index: 2;

      .form-container {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: #fff;
        transition: transform 0.5s;
      }

      .slide-up {
        transform: translateY(390px);
      }

      // padding: 10px 16px 0;
    }

    .bgmask {
      background: #00000080;
      position: fixed;
      top: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
    }
  }

  .yy-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    img {
      width: 24px;
      margin-bottom: 20px;
      animation: tbmove 0.7s infinite;
      // height: ;
    }

    &-btn {
      width: 80%;

      button {
        width: 100%;
        height: 43px;
        border-radius: 24px;
        background-color: #000000;
        color: #fff;
        border: 1px solid #FFFFFF;
        // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 1));
      }
    }
  }

  .right-btn-box{
    display: flex;
    flex-direction: column;

    img{
      margin-top: 10px;
      width: 44px;
      height: 44px;
    }
  }
  @keyframes tbmove {
    from {
      margin-bottom: 10px;
    }

    to {
      margin-bottom: 20px;
    }
  }


  </style>
